import { useEffect } from "react";
import { apiUrl } from "../config/settings";
import { setIsLogin, setPaletteMode, setSelectedPlugin, setUser } from "../store/userSettingsSlice";
import { useDispatch, useSelector } from "react-redux";
import { setBiz } from "../store/bizSlice";
import http from "../http";
import { getCookie, getFromLocalStorage } from "../config/functions";
import useLogOut from "../hooks/useLogOut";
import useDataManager from "hooks/useDataManager";
import useWebSocket from "hooks/useWebSocket";
import { setIsSystem } from "store/sysSlice";

const ApiProvider = ({ children }) => {
  const { logOut } = useLogOut();
  const dispatch = useDispatch();

  const { connected } = useWebSocket();
  const { getInitData } = useDataManager()
  const lang = useSelector((state) => state?.userSettings?.selectedLang);
  const isLogin = useSelector((state) => state?.userSettings?.isLogin);
  const paletteMode = getFromLocalStorage("paletteMode")

  document.dir = lang?.dir;

  useEffect(() => {
    if (paletteMode) dispatch(setPaletteMode(paletteMode))
    else dispatch(setPaletteMode("light"))

    if (isLogin) {
      const token = getCookie("authAnalytics");
      const biz = getFromLocalStorage("biz");
      const localUser = getFromLocalStorage("user");
      const selectedPlugin = getFromLocalStorage("selectedPlugin");

      try {
        if (token) {
          const findBiz = localUser?.business?.find(b => b?.id === biz?.id)
          const findMainBiz = localUser?.business?.find(b => b?.isMain)
          const userRole = findBiz?.userRole || findMainBiz?.userRole

          dispatch(setUser({ ...localUser, userRole: userRole, department: findBiz?.department }));
          dispatch(setBiz(biz));

          if (selectedPlugin) {
            dispatch(setSelectedPlugin(selectedPlugin));
          }

          else {
            dispatch(setIsLogin(false));
            logOut();
          }

          if (biz) connected(biz?.path)

          http.get(`${apiUrl}/users/info`).then((response) => {
            if (response?.status === 200) {
              const sys = getCookie("sys")
              if (sys) dispatch(setIsSystem(true));
              getInitData(userRole)
              dispatch(setIsLogin(true));
            }
          })
        }

        else {
          dispatch(setIsLogin(false));
        }
      }
      catch (error) {
        dispatch(setIsLogin(false));
        logOut();
        console.error("Auth error");
      }

    }
  }, []);

  return children;
};

export default ApiProvider;
